export enum GroupType {
  CHAMPIONS = 'champions',
  COMPANY = 'company',
  GENERAL = 'general',
}

export enum GroupVisibility {
  PRIVATE = 'private',
  PUBLIC = 'public',
}

export enum GroupMemberRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
}

export enum GroupPostType {
  DISCUSSION = 'discussion',
  WORKOUT_SHARE = 'workout_share',
}

export interface Group {
  id: string
  createdAt: string
  updatedAt: string
  name: string
  description?: string
  imageFileId?: string
  type: GroupType
  visibility: GroupVisibility
  inviteCode?: string
  isActive: boolean
  hustlerId: string
  memberCount?: number
  myRole?: GroupMemberRole
  isJoined?: boolean
}

export interface GroupHustler {
  id: string
  name: string
  username?: string
  profilePhotoFileId?: string
}

export interface GroupMember {
  id: string
  groupId: string
  hustlerId: string
  role: GroupMemberRole
  createdAt: string
  hustler?: {
    id: string
    name: string
    username?: string
    profile?: { profilePhotoFileId?: string }
  }
}

export interface GroupPost {
  id: string
  createdAt: string
  updatedAt: string
  text: string
  photoFileId?: string
  postType: GroupPostType
  isPinned: boolean
  hustlerId: string
  groupId?: string
  workoutId?: string
  hustler?: GroupHustler
  workout?: { id: string; title?: string; name?: string }
  commentCount?: number
}

export interface GroupPostsListResponse {
  data: GroupPost[]
  limit: number
  offset: number
  total: number
}

export interface GroupMemberResponse {
  id: string
  groupId: string
  hustlerId: string
  role: GroupMemberRole
  createdAt: string
  group?: Partial<Group>
  hustler?: {
    id: string
    name: string
    username?: string
    profile?: { profilePhotoFileId?: string }
  }
}

export interface DiscoverGroupsParams {
  limit?: number
  offset?: number
  search?: string
}

export interface CreateGroupPostInput {
  text: string
  photoFileId?: string
  postType?: GroupPostType
  workoutId?: string
}

export interface UpdateGroupPayload {
  name?: string
  description?: string
  imageFileId?: string
  type?: GroupType
  visibility?: GroupVisibility
  isActive?: boolean
}

export interface CreateGroupPayload {
  name: string
  description?: string
  type?: GroupType
  visibility?: GroupVisibility
  hustlerId: string
}

export interface AdminGroupsListResponse {
  data: Group[]
  total: number
}

export interface AdminGroupMembersListResponse {
  data: GroupMemberResponse[]
  total: number
}

export interface AdminGroupPostsListResponse {
  data: GroupPost[]
  total: number
}
